module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAMAAAA4a6b0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURUdwTADI5wZW/wZW/wBQ/wZV/wC/3wZV/wDJ5gZV/wDI5gCh7QVV/wZV/wDE5wBV/wZV/wRV/wZV/wZW/wZU/wDJ5gdW/ywrd+kAAAAVdFJOUwBx9d8f0Qi/zobzGZKl2Ay1PW9TWy18XgsAAACVSURBVCjPzZDbDoMgEEQHKrCAeGmr//+pXQsuYGLSx54nJieQGYC3z6w4sIpCIGX5OO4nL05x2r5QBLSYhW8UwcpCxO4AtQmqN1M11JsqtvCrodvXugZGzMitqWm9noPMcCyluhQYMrj+zj3z6DLPI/kS/AwkacDKt3V02/ohwaDf82fGSfDtuMS/5vIinXh2XEpYIj4AEiLbqtZfKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/allProduct/div2.png
// module id = a9fc
// module chunks = 0